import { CircularLoader, SuperEllipse } from '@themenu/design-system'
import { eventSenderManager } from 'lib/analytics/eventSender'
import { useState } from 'react'
import { useNotifications } from 'providers/notifications/useNotifications'
import NotificationList from './NotificationList'

const NotificationArea: React.FC = () => {
  const { data: notifications, isLoading } = useNotifications()

  const list = notifications?.content || []

  const notReadQuantity = list.filter(({ read }) => !read).length ?? 0

  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = () => {
    const nextOpen = !isOpen
    setIsOpen(nextOpen)
    eventSenderManager.sendEvent({
      label: nextOpen
        ? 'notification panel opened'
        : 'notification panel closed',
      metadata: {
        notReadQuantity,
        totalCount: list.length
      }
    })
  }

  if (isLoading) return <CircularLoader size={40} />

  if (list.length === 0) return null

  return (
    <div>
      <div className="relative">
        <button
          className="p-0 appearance-none transition-transform hover:scale-105"
          onClick={handleToggle}
        >
          <SuperEllipse
            size={40}
            icon="bell"
            colorSet={isOpen ? 'primary' : 'default'}
          />
        </button>
        {notReadQuantity > 0 && (
          <div className="absolute w-8 h-8 bg-background-highlighted-critical rounded-full top-2 right-2"></div>
        )}
        <NotificationList
          isOpen={isOpen}
          list={list}
          onClose={() => {
            setIsOpen(false)
            eventSenderManager.sendEvent({
              label: 'notification panel closed',
              metadata: {
                notReadQuantity,
                totalCount: list.length,
                source: 'list'
              }
            })
          }}
        />
      </div>
    </div>
  )
}

export default NotificationArea
